/**
 * 金額ユーティリティ。**金額は常に整数(円)。**(yojitsu-system と共通の方式)
 */
import type { Yen } from './types';

/** 1件あたりの上限(誤入力の歯止め) */
export const MAX_AMOUNT: Yen = 100_000_000;

/** DBに保存できる金額か(整数・0以上・上限以内)。単価0円(未設定)は許容する */
export function isValidAmount(v: unknown): v is Yen {
  return typeof v === 'number' && Number.isInteger(v) && v >= 0 && v <= MAX_AMOUNT;
}

/** 3桁区切り。例) 1234567 → '1,234,567' */
export function formatYen(v: Yen): string {
  return v.toLocaleString('ja-JP');
}

/** 入力文字列(全角数字・カンマ・空白を含みうる)を整数に変換する。不正なら null */
export function parseAmount(input: string): Yen | null {
  const normalized = input
    .replace(/[０-９]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0))
    .replace(/[,，\s円]/g, '')
    .trim();
  if (normalized === '' || !/^\d+$/.test(normalized)) return null;
  const n = Number(normalized);
  return isValidAmount(n) ? n : null;
}
